<template>
  <p class="legal-text">
    Op deze opdracht zijn de

    <router-link target="_blank" to="/leveringsvoorwaarden"
      >Leveringsvoorwaarden van Koninklijke Rijnja B.V.
    </router-link>
    van toepassing.
  </p>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped></style>
